import get from 'lodash/get';
import moment from 'moment';
import { createSelector } from 'reselect';

import { LAYOUT_MAP } from '@src/utils/constants';
import featureNames from '@src/utils/featureToggle/constants';
import { METRICS, METRIC_LIST } from '@utils/metricsList';

import { SCOPE } from './types';

const selector = (store) => get(store, SCOPE);
const product = window.conviva.module || 'Activation';

export default selector;

export const getUserProfile = createSelector(
  selector,
  (store) => get(store, 'profiles', []).find((profile) => profile.is_selected) || {},
);

export const selectedUserRoleSelector = createSelector(getUserProfile, (profile) =>
  get(profile, 'role', ''),
);

export const getFirstAppliedFilter = createSelector(selector, (commonStore) =>
  get(commonStore, 'appliedFilters[0]', {}),
);

export const presetFidSelector = createSelector(
  getFirstAppliedFilter,
  (filter) => filter.presetFid || null,
);

export const supportedMetrics = createSelector(selector, () => {
  return METRICS[product];
});

export const supportedSortedMetrics = createSelector(selector, () => {
  return METRICS[product];
});

export const dodSelector = createSelector(selector, (commonStore) => commonStore.dod);

export const layoutSelector = createSelector(selector, (commonStore) => commonStore.layout);

export const horizontalLayoutSelector = createSelector(
  layoutSelector,
  (layout) => layout === LAYOUT_MAP.horizontal,
);
